import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportJobOrderReversalService extends GenericService {
    constructor() {
        super('/reports/job_order_reversal', axiosInstance);
    }
}

export default new ReportJobOrderReversalService();
